import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { Link } from '@egw/components'

export const ApexDisclosuresV3: FC = () => {
  const { t } = useTranslation('features-enrollment')

  return (
    <div className="typo-primary-sm-light text-text-meta flex flex-col gap-2xs mt-sm mb-5xl md:mb-md">
      <p>{t(`common.disclosures_footer.v3.apex_footer_disclosure_1`)}</p>
      <p>
        {t(`common.disclosures_footer.v3.apex_footer_disclosure_2`)}&nbsp;
        <Link
          className="text-text-action typo-primary-sm font-semibold"
          href={t(`common.disclosures_footer.v3.apex_footer_disclosures_link_1`)}
        >
          {t(`common.disclosures_footer.v3.apex_footer_disclosures_link_1_text`)}
        </Link>
        .
      </p>
      <p className="text-text-meta typo-primary-sm-bold">
        {t(`common.disclosures_footer.v3.apex_footer_disclosure_3`)}
      </p>
      <p>
        {t(`common.disclosures_footer.v3.apex_footer_disclosure_4`)}&nbsp;
        <Link
          className="text-text-action typo-primary-sm font-semibold"
          href={t(`common.disclosures_footer.v3.apex_footer_disclosures_link_2`)}
        >
          {t(`common.disclosures_footer.v3.apex_footer_disclosures_link_2_text`)}
        </Link>
        .
      </p>
      <p>{t(`common.disclosures_footer.v3.apex_footer_disclosure_5`)}</p>
      <p>{t(`common.disclosures_footer.v3.apex_footer_disclosure_6`)}</p>
      <p>{t(`common.disclosures_footer.v3.apex_footer_disclosure_7`)}</p>
    </div>
  )
}
